export function useSocialShare() {
  const openWindow = (url: string, width: number = 640, height: number = 480) => {
    const winTop = screen.height / 2 - height / 2
    const winLeft = screen.width / 2 - width / 2
    window.open(
      url,
      'sharer',
      'top=' + winTop + ',left=' + winLeft + ',toolbar=0,status=0,width=' + width + ',height=' + height
    )
  }

  const shareFb = () => {
    openWindow('http://www.facebook.com/sharer.php?u=' + encodeURIComponent(window.location.href))
  }
  const shareXPlatform = () => {
    openWindow(
      'https://twitter.com/share?url=' +
        encodeURIComponent(window.location.href) +
        '&text=' +
        encodeURIComponent(document.title)
    )
  }
  const shareWsApp = () => {
    openWindow('whatsapp://send?text=' + encodeURIComponent(window.location.href))
  }

  return {
    shareFb,
    shareXPlatform,
    shareWsApp,
  }
}
